<div class="trigger-builder rounded w-100 p-6" [formGroup]="triggerForm">
  <h3 class="body-400 mb-2">Triggers</h3>
  <div class="tc--dark mb-6 small-300">
    Triggers determine when a new statement will be generated for {{ statementRecipientLabel$ | async }}s. The actual day and time a
    statement is sent depends on your throttling settings.
  </div>
  <div class="mb-6">
    <div
      *ngFor="let triggerControl of triggersControlArray.controls; let i = index"
      class="col mb-6 align-items-center align-middle d-flex flex-row"
      formArrayName="steps"
    >
      <div class="flex-grow w-100" [formGroupName]="i">
        <app-trigger-builder
          [formControl]="triggerControl"
          [index]="i"
          [isOnlyTrigger]="triggersControlArray.controls.length === 1"
          [order]="i + 1"
          (removeTrigger)="removeTrigger(i)"
          (updated)="updateExistingTrigger(i)"
        />
      </div>
    </div>
    <ng-container>
      <div
        *ngFor="let addTriggerControl of addTriggersControlArray.controls; let index = index"
        class="col mb-6 align-items-center align-middle d-flex flex-row"
        [formArray]="addTriggersControlArray"
      >
        <div class="flex-grow w-100">
          <app-trigger-builder
            [formControl]="addTriggerControl"
            [index]="index + triggersControlArray.controls.length"
            (removeTrigger)="removeAddTrigger()"
            (updated)="updateNewTrigger()"
          />
        </div>
      </div>
    </ng-container>
    <div *ngIf="!addTriggersControlArray.controls.length && !disabled">
      <div class="p-2 d-flex flex-row align-items-center">
        <div class="flex-shrink me-4">
          <div class="add-indicator" (click)="addTrigger()">
            <anduin-icon name="plus" stroke="currentColor" />
          </div>
        </div>
        <div>
          <button class="text-button" (click)="addTrigger()">Add Trigger</button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="ms-3 d-flex flex-row align-items-center"
    [ngClass]="{ 'no-triggers-checked': triggerForm.controls['no_trigger_statement_enabled']?.value }"
    [formGroup]="whenNoTriggersGroup"
  >
    <mat-checkbox class="mat-checkbox-complex-label" [formControl]="noTriggerStatementEnabled">
      <div class="d-flex flex-row align-items-baseline">
        <p class="content-nowrap">By default, send statements on the</p>
        <select class="form-select ms-2 me-2" (change)="$event.stopPropagation()" formControlName="no_trigger_statement_occurrence">
          <option *ngFor="let option of OCCURRENCE_OPTIONS" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
        <select class="form-select me-2" (change)="$event.stopPropagation()" formControlName="no_trigger_statement_day">
          <option *ngFor="let option of DAY_OPTIONS" [value]="option">
            {{ option }}
          </option>
        </select>
        <p class="content-nowrap">of the month</p>
      </div>
    </mat-checkbox>
  </div>
</div>
